export const PGA_MODULE = {
  value: "privilege_governance_assurance",
  label: "Privilege Governance Assurance",
};

export const PGA_ALERT_DAYS = 0;

export const DELETE_LABEL = "Privilege Governance Assurance";